


interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const dietconsultations: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "best-dietitian-in-dubai",
        "meta": {
            "title": "Best Dietitian in Dubai | Elite Body Home",
            "description": "Get personalized nutrition plans from top dietitians in Dubai for weight management, disease control, and overall wellness.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/best-dietitian-in-dubai/",
            "og": {
                "title": "Best Dietitian in Dubai | Elite Body Home",
                "description": "Personalized nutrition plans for weight management and overall wellness",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-50.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Best Dietitian in Dubai"],
        "hero": {
            "title": "Best Dietitian in Dubai",
            "subtitle": "Personalized Nutrition Planning",
            "description": "It is widely known that a balanced diet is essential for maintaining a healthy lifestyle and therefore seeking a dietician is one of the quickest ways you can reach your wellness needs. A dietician doesn't just help you shed pounds — he or she crafts a custom-made nutrition program to fuel your body's repair, whether you want to control a health issue, energize problem areas or enhance general wellness. There are dieticians in Dubai who are highly skilled at providing personalized nutritional advice and meal planning for improved results."
        },
        "howItWorks": {
            "title": "How Does Dietitian Consultation Work?",
            "description": "Dietitian evaluate your diet patterns and provide a unique plan according to your health plan. Here's what to expect when visiting a dietician in Dubai."
        },
        "procedureSteps": {
            "heading": "Procedure Overview",
            "para": "Here's what to expect when visiting a dietician in Dubai:",
            "steps": [
                {
                    "title": "Comprehensive Assessment",
                    "desc": "The first step includes a detailed review of your medical history, eating patterns, and nutritional needs. We may review blood reports, medical history, and discuss your health goals.",
                    "icon": "fa-solid fa-clipboard-user"
                },
                {
                    "title": "Customized Nutrition Plan",
                    "desc": "After evaluating the initial assessment, the dietician will plan a diet specifically for you. That plan could be about maintaining weight, boosting gut health, controlling blood sugar or managing ailments like hypertension, elevated cholesterol or food intolerances.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Follow up Sessions",
                    "desc": "In Dubai, dieticians provide continuous support with follow-up sessions to monitor your success & recalibrate your diet if needed. It ensures that you are on the correct path to achieve your health aims.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Nutritional Education",
                    "desc": "Dieticians help patients learn about nutrition and better food choices, which is one of their main jobs. This enables you to manage your health over time.",
                    "icon": "fa-solid fa-book-open"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Consulting a Dietitian",
            "subheading": "Achieve your health goals with professional guidance",
            "para": "Collaborating with a leading dietician in Dubai provides numerous benefits, not only through short-term plans such as diet and weight loss, but also through long-term health management. Below are the key benefits:",
            "items": [
                {
                    "title": "Personalized Nutrition Plans",
                    "desc": "Dieticians also provide customized diet plans according to your age, health-related issues, and lifestyle.",
                    "icon": "fa-solid fa-user-gear"
                },
                {
                    "title": "Weight Management",
                    "desc": "If the goal you have in mind is to lose, gain, or maintain weight, a dietician will help you make the right choices to meet those goals without resorting to extreme measures.",
                    "icon": "fa-solid fa-weight-scale"
                },
                {
                    "title": "Better Disease Management",
                    "desc": "If you have chronic conditions such as diabetes, heart disease, or digestive disorders, a dietician can help you with proper nutrition to optimize your condition and prevent complications.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "Improved Energy and Vitality",
                    "desc": "Eating a well-balanced meal will keep you feeling energized throughout the day. Dieticians are all about the right nutrients and how a great combo can facilitate your overall wellness.",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Can Benefit from a Dietitian?",
            "subheading": "",
            "para": "Dietician initially caters to a broader spectrum of individuals but since they are focusing on health outcomes, a lot of individuals can benefit from them. Here are some of the populations that would gain the most:",
            "items": [
                {
                    "title": "Chronic Conditions Individuals",
                    "desc": "For example, people who have chronic illnesses such as diabetes, high blood pressure, high cholesterol or digestive issues need to pay extra close attention to how they manage their diets.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "Athletes and Fitness Enthusiasts",
                    "desc": "Athletic performance and recovery needs to be individualized diet. High-performance physical activity has unique demands, which dieticians can plan nutrition to support.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "Pregnant and Breastfeeding Individuals",
                    "desc": "An adequate diet is important in pregnancy and lactation for the health of both mother and baby. Dieticians instruct on meeting the nutritional needs of pregnancy and postpartum recovery.",
                    "icon": "fa-solid fa-baby"
                },
                {
                    "title": "People Looking to Lose Weight",
                    "desc": "If you have been experiencing challenges in your effort to lose weight, a dietician can determine the most appropriate way for you to achieve safe and effective weight loss through proper nutrition.",
                    "icon": "fa-solid fa-person-walking"
                },
                {
                    "title": "Children and Adolescents",
                    "desc": "Especially if specific dietary restrictions or health concerns are given, a dietician can assist parents ensure their children and adolescents are receiving the nutrients they require to develop.",
                    "icon": "fa-solid fa-children"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Before Your Consultation",
            "subheading": "",
            "para": "Prepare to get the most out of your dietician consultation Here's what you can do to get ready for your session:",
            "items": [
                {
                    "title": "Keep a Food Diary",
                    "desc": "Keep a log of everything you eat and drink for at least a week prior to your appointment. This will give the dietician an idea of what you are currently eating and what things they can improve on.",
                    "icon": "fa-solid fa-book"
                },
                {
                    "title": "Gather Medical Records",
                    "desc": "If you do have any pre-existing health conditions, come prepared with your medical records, results of blood tests, and the names of medications you are currently taking.",
                    "icon": "fa-solid fa-folder-open"
                },
                {
                    "title": "Set Clear Goals",
                    "desc": "Identify in specific terms what you want to accomplish — weight loss, control of a health condition or better overall health.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "Be Honest",
                    "desc": "If you are honest regarding your eating habits, lifestyle and challenges, it will help the dietician chart out a better suited plan for you.",
                    "icon": "fa-solid fa-hand-holding-heart"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "The benefits of seeing a dietitian depend on your goals. Here's what you can expect:",
            "items": [
                {
                    "title": "Sustainable Weight Loss or Gain",
                    "desc": "With a structured nutrition plan in place, your body should see steady and gradual change in response to your diet, and will be safe from the dangerous cycle of yo-yo dieting.",
                    "icon": "fa-solid fa-scale-balanced"
                },
                {
                    "title": "Improved Health Markers",
                    "desc": "After following a dietician's program, many people see lower cholesterol, stabilized blood sugar levels and improved blood pressure.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "Enhanced Energy and Mood",
                    "desc": "Balanced nutrition promotes consistent energy levels over the course of the day and can even enhance mental clarity and mood.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Better Digestive Health",
                    "desc": "Specific diet changes help manage bloating, indigestion, and other digestive symptoms.",
                    "icon": "fa-solid fa-stomach"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maintain and enhance your results:",
            "items": [
                {
                    "title": "Follow the Plan Consistently",
                    "desc": "Stick to your customized nutrition plan for optimal results.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "Attend Follow-up Sessions",
                    "desc": "Regular check-ins with your dietician help adjust the plan as needed.",
                    "icon": "fa-solid fa-calendar-days"
                },
                {
                    "title": "Maintain Healthy Habits",
                    "desc": "Incorporate the nutritional education into your daily life for long-term benefits.",
                    "icon": "fa-solid fa-heart-circle-plus"
                },
                {
                    "title": "Monitor Progress",
                    "desc": "Keep track of your health markers and improvements.",
                    "icon": "fa-solid fa-chart-simple"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How often should I see a dietitian?",
                    "answer": "Frequency depends on your goals, but typically starts with weekly or bi-weekly sessions, then tapers to monthly maintenance."
                },
                {
                    "question": "Will I need to follow a restrictive diet?",
                    "answer": "Our dietitians create sustainable plans tailored to your preferences and lifestyle, not extreme restrictions."
                },
                {
                    "question": "Can a dietitian help with food allergies?",
                    "answer": "Yes, they can create specialized plans to accommodate allergies and intolerances while ensuring proper nutrition."
                },
                {
                    "question": "How quickly will I see results?",
                    "answer": "This varies by individual, but many notice improved energy within days and weight changes within 2-4 weeks."
                },
                {
                    "question": "Do you provide meal plans?",
                    "answer": "Yes, you'll receive customized meal plans and grocery lists based on your preferences and health needs."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Bafyhgnner-Image-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 7,
            "title": "Dietitian Consultation in Dubai",
            "description": "Personalized nutrition planning with top dietitians for weight management and overall wellness.",
            "price": 499
        }
    },
    "ar": {
        "url": "best-dietitian-in-dubai",
        "meta": {
            "title": "أفضل أخصائي تغذية في دبي | ايليت بودي هوم",
            "description": "احصل على خطط تغذية شخصية من أفضل أخصائيي التغذية في دبي لإدارة الوزن، التحكم في الأمراض، والرفاهية العامة.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/best-dietitian-in-dubai",
            "og": {
                "title": "أفضل أخصائي تغذية في دبي | ايليت بودي هوم",
                "description": "خطط تغذية شخصية لإدارة الوزن والرفاهية العامة",
                "image": "https://www.elitebodyhome.com/images/dietitian-consultation-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "أفضل أخصائي تغذية في دبي"],
        "hero": {
            "title": "أفضل أخصائي تغذية في دبي",
            "subtitle": "خطط تغذية شخصية",
            "description": "النظام الغذائي المتوازن هو أحد الأسس الضرورية للحفاظ على نمط حياة صحي، ولهذا يُعتبر الاستعانة بأخصائي تغذية من أسرع الطرق لتحقيق أهدافك الصحية، حيث لا يساعدك أخصائي التغذية على خسارة الوزن فقط، بل يُصمم لك برنامجًا غذائيًا خصيصًا لتغذية جسمك وتحفيز تعافيه، سواء كنت ترغب في السيطرة على حالة صحية معينة، أو زيادة الطاقة، أو إنقاص الوزن، أو تعزيز صحتك العامة. في دبي، يوجد نخبة من أخصائيي التغذية ذوي الكفاءة العالية، ممن يقدمون استشارات غذائية شخصية وأنظمة غذائية مصممة خصيصًا لتحقيق أفضل النتائج."
        },
        "howItWorks": {
            "title": "كيف تعمل استشارة أخصائي التغذية؟",
            "description": "يقوم أخصائي التغذية بتقييم نظامك الغذائي ووضع خطة مخصصة تتوافق مع حالتك الصحية. إليك ما يمكن توقعه عند زيارة أخصائي تغذية في دبي."
        },
        "procedureSteps": {
            "heading": "خطوات الإجراء",
            "para": "إليك ما يمكن توقعه عند زيارة أخصائي تغذية في دبي:",
            "steps": [
                {
                    "title": "تقييم شامل",
                    "desc": "تبدأ الزيارة بمراجعة دقيقة لتاريخك الطبي، وعاداتك الغذائية، واحتياجاتك من العناصر الغذائية، وقد تُتطلب فحوصات الدم ومناقشة الأهداف الصحية التي تسعى لتحقيقها.",
                    "icon": "fa-solid fa-clipboard-user"
                },
                {
                    "title": "نظام غذائي مخصص",
                    "desc": "يقوم أخصائي التغذية بعد التقييم الأولي بوضع حمية غذائية خاصة بك، وقد يشمل ذلك خطة للحفاظ على الوزن، أو تعزيز صحة الجهاز الهضمي، أو ضبط مستويات السكر في الدم، أو إدارة الأمراض مثل ارتفاع ضغط الدم أو الكوليسترول، أو حالات عدم تحمل بعض الأطعمة.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "جلسات المتابعة",
                    "desc": "يحرص أخصائيو التغذية في دبي على تقديم دعم مستمر من خلال جلسات متابعة دورية لمراقبة التقدم وإجراء أي تعديلات ضرورية على خطتك الغذائية. وهذا يضمن أنك تسير في المسار الصحيح نحو تحقيق أهدافك الصحية.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "التثقيف الغذائي",
                    "desc": "تُعد من المهام الأساسية لأخصائي التغذية أيضًا توعية المرضى بالتغذية السليمة وخيارات الطعام الأفضل، مما يساعدك على إدارة صحتك بشكل فعال على المدى الطويل.",
                    "icon": "fa-solid fa-book-open"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد الاستشارة",
            "subheading": "احقق أهدافك الصحية بإرشاد احترافي",
            "para": "يساهم التعاون مع أخصائي تغذية رائد في دبي في تحقيق العديد من الفوائد، ليس فقط من خلال خطط قصيرة المدى مثل الحمية وإنقاص الوزن، بل أيضًا من خلال خطط فعالة على المدى الطويل لإدارة الصحة. وفيما يلي أبرز الفوائد:",
            "items": [
                {
                    "title": "خطط تغذية مخصصة",
                    "desc": "يقوم أخصائي التغذية بوضع خطط غذائية مصممة خصيصًا حسب عمرك، وحالتك الصحية، ونمط حياتك.",
                    "icon": "fa-solid fa-user-gear"
                },
                {
                    "title": "إدارة الوزن",
                    "desc": "سواء كنت ترغب في فقدان الوزن أو زيادته أو الحفاظ عليه، سيساعدك أخصائي التغذية على اتخاذ الخيارات الصحيحة لتحقيق هدفك دون اللجوء إلى وسائل قاسية.",
                    "icon": "fa-solid fa-weight-scale"
                },
                {
                    "title": "تحسين إدارة الأمراض",
                    "desc": "إذا كنت تعاني من أمراض مزمنة مثل السكري أو أمراض القلب أو اضطرابات الجهاز الهضمي، يمكن لأخصائي التغذية مساعدتك في اختيار الغذاء المناسب لتحسين حالتك والحد من المضاعفات.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "زيادة النشاط والحيوية",
                    "desc": "يساعدك تناول وجبات متوازنة على الشعور بالطاقة والنشاط طوال اليوم. يعتمد أخصائيو التغذية على التركيبة المثالية من العناصر الغذائية لتعزيز صحتك العامة.",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "eligibility": {
            "heading": "الأشخاص المؤهلون للاستفادة",
            "subheading": "",
            "para": "رغم أن أخصائي التغذية يقدم خدماته لشريحة واسعة من الناس، إلا أن هناك فئات محددة يمكن أن تستفيد بشكل كبير من استشارته، خاصةً مع التركيز على تحسين الصحة. وفيما يلي أبرز الفئات التي تستفيد بشكل ملحوظ:",
            "items": [
                {
                    "title": "الأشخاص المصابون بحالات مزمنة",
                    "desc": "مثل مرضى السكري، وارتفاع ضغط الدم، وارتفاع الكوليسترول، ومشكلات الجهاز الهضمي. هؤلاء بحاجة إلى اهتمام خاص بنمطهم الغذائي، ويمكن لأخصائي التغذية تصميم خطة غذائية مناسبة لحالتهم الصحية الدقيقة.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "الرياضيون ومحبو اللياقة البدنية",
                    "desc": "يحتاج الأداء البدني العالي والتعافي إلى تغذية مدروسة ومخصصة. يضع أخصائي التغذية خططًا داعمة تتناسب مع المتطلبات الفريدة لكل رياضي أو ممارس للنشاط البدني المكثف.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "الحوامل والمرضعات",
                    "desc": "تُعد التغذية السليمة خلال الحمل والرضاعة أمر بالغ الأهمية لصحة الأم والجنين. يوجه أخصائي التغذية الأمهات لتلبية احتياجاتهن الغذائية أثناء الحمل وبعد الولادة.",
                    "icon": "fa-solid fa-baby"
                },
                {
                    "title": "الأشخاص الراغبون في خسارة الوزن",
                    "desc": "إذا كنت تواجه صعوبة في إنقاص وزنك، يمكن لأخصائي التغذية أن يساعدك على تحقيق فقدان وزن صحي وآمن من خلال خطط غذائية فعالة ومدروسة.",
                    "icon": "fa-solid fa-person-walking"
                },
                {
                    "title": "الأطفال والمراهقون",
                    "desc": "يساعد أخصائي التغذية الآباء في ضمان حصول أبنائهم على العناصر الغذائية الأساسية لنمو سليم، خاصةً في حالات وجود حساسية غذائية أو مخاوف صحية.",
                    "icon": "fa-solid fa-children"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل الجلسة",
            "subheading": "",
            "para": "استعد جيداً للحصول على أقصى فائدة من جلستك لاستشارة أخصائي التغذية. إليك بعض الخطوات التي يمكنك القيام بها قبل الموعد:",
            "items": [
                {
                    "title": "احتفظ بمذكرة غذائية",
                    "desc": "قم بتسجيل كل ما تتناوله من طعام وشراب لمدة أسبوع على الأقل قبل الموعد. سيساعد ذلك أخصائي التغذية على فهم نمطك الغذائي الحالي وتحديد الجوانب التي يمكن تحسينها.",
                    "icon": "fa-solid fa-book"
                },
                {
                    "title": "اجمع سجلاتك الطبية",
                    "desc": "إذا كنت تعاني من أي حالات صحية مزمنة، احرص على إحضار سجلاتك الطبية، ونتائج الفحوصات، وأسماء الأدوية التي تتناولها حالياً.",
                    "icon": "fa-solid fa-folder-open"
                },
                {
                    "title": "حدد أهدافك بوضوح",
                    "desc": "فكر جيداً فيما تريد تحقيقه من الجلسة، سواء كان إنقاص الوزن، أو السيطرة على حالة صحية معينة، أو تحسين صحتك العامة.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "كن صادقاً",
                    "desc": "كلما كنت صريحاً في وصف عاداتك الغذائية ونمط حياتك والتحديات التي تواجهها، ساعدت أخصائي التغذية على وضع خطة غذائية ملائمة ومخصصة لك.",
                    "icon": "fa-solid fa-hand-holding-heart"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "تعتمد نتائج الاستشارة الغذائية على الأهداف التي تسعى لتحقيقها. إليك ما يمكن توقعه:",
            "items": [
                {
                    "title": "خسارة أو زيادة وزن بشكل دائم",
                    "desc": "سيبدأ جسمك في التفاعل بشكل تدريجي وآمن مع النظام الغذائي من خلال خطة تغذية منظمة، بعيداً عن الأنظمة القاسية مثل اليويو دايت.",
                    "icon": "fa-solid fa-scale-balanced"
                },
                {
                    "title": "تحسن في المؤشرات الصحية",
                    "desc": "يلاحظ الكثير من المرضى انخفاضاً في نسبة الكوليسترول، واستقرار مستويات السكر في الدم، وتحسناً في ضغط الدم بعد اتباع خطة أخصائي التغذية.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "زيادة النشاط وتحسن الحالة المزاجية",
                    "desc": "يساهم النظام الغذائي المتوازن في تعزيز مستويات الطاقة خلال اليوم، وقد ينعكس ذلك أيضاً إيجاباً على صفاء الذهن والمزاج العام.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "تحسن في صحة الجهاز الهضمي",
                    "desc": "تساعد التعديلات الغذائية المخصصة في التخفيف من الانتفاخ، وعسر الهضم، وأعراض الجهاز الهضمي الأخرى.",
                    "icon": "fa-solid fa-stomach"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "للحفاظ على النتائج وتعزيزها:",
            "items": [
                {
                    "title": "التزم بالخطة بانتظام",
                    "desc": "التزم بخطة التغذية المخصصة لتحقيق أفضل النتائج.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "احضر جلسات المتابعة",
                    "desc": "الفحوصات المنتظمة مع أخصائي التغذية تساعد في تعديل الخطة حسب الحاجة.",
                    "icon": "fa-solid fa-calendar-days"
                },
                {
                    "title": "حافظ على العادات الصحية",
                    "desc": "طبق ما تعلمته عن التغذية في حياتك اليومية لتحقيق فوائد طويلة المدى.",
                    "icon": "fa-solid fa-heart-circle-plus"
                },
                {
                    "title": "راقب التقدم",
                    "desc": "تابع مؤشرات صحتك والتحسينات التي تطرأ عليها.",
                    "icon": "fa-solid fa-chart-simple"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم مرة يجب أن أزور أخصائي التغذية؟",
                    "answer": "يعتمد التكرار على أهدافك، لكنه يبدأ عادةً بجلسات أسبوعية أو كل أسبوعين، ثم يصبح شهرياً للصيانة."
                },
                {
                    "question": "هل سأحتاج إلى اتباع نظام غذائي صارم؟",
                    "answer": "يضع أخصائيو التغذية لدينا خططاً مستدامة مصممة حسب تفضيلاتك ونمط حياتك، وليس قيوداً شديدة."
                },
                {
                    "question": "هل يمكن لأخصائي التغذية المساعدة في حالات الحساسية الغذائية؟",
                    "answer": "نعم، يمكنهم وضع خطط خاصة تستثني الأطعمة المسببة للحساسية مع ضمان التغذية السليمة."
                },
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "يختلف ذلك من شخص لآخر، لكن الكثيرون يلاحظون تحسناً في الطاقة خلال أيام، وتغيراً في الوزن خلال 2-4 أسابيع."
                },
                {
                    "question": "هل تقدمون خطط وجبات؟",
                    "answer": "نعم، ستحصل على خطط وجبات وقوائم تسوق مخصصة بناءً على تفضيلاتك واحتياجاتك الصحية."
                }
            ]
        }
    }
}